import { OrdersModel } from '@pukka/api';
import { Text } from '@pukka/ui-components';

import ReceiptDiscountTable from './ReceiptDiscountTable';
import ReceiptItemTable from './ReceiptItemTable';
import RewardRedemptionInfo from './RewardRedemptionInfo';

interface ReceiptListItemProps {
  readonly invoiceDetail: OrdersModel.OrderDetail;
}

function ReceiptListItem({ invoiceDetail }: ReceiptListItemProps) {
  const { loyalty, order_items: orderItems } = invoiceDetail;

  const hasDiscount = invoiceDetail.order_discounts.length > 0;
  const hasRewardRedemption = loyalty && loyalty.redemption && loyalty.redemption.reward;
  const redeemReward = loyalty?.redemption?.reward_checkout_title || loyalty?.redemption?.reward;

  if (Array.isArray(orderItems) && orderItems.length > 0) {
    return (
      <div>
        <ReceiptItemTable checkouts={orderItems} />

        {(hasDiscount || hasRewardRedemption) && (
          <>
            <hr />
            <div className="m-0 my-2 w-full rounded-lg bg-neutral-50 px-4 py-2 sm:ml-[50%] sm:w-[50%]">
              <ReceiptDiscountTable discounts={invoiceDetail.order_discounts} />
              {hasRewardRedemption && (
                <RewardRedemptionInfo redeemReward={redeemReward} totalRedeemAmount={invoiceDetail.total_redeem_amount} />
              )}
            </div>
          </>
        )}
      </div>
    );
  }

  const items: React.ReactNode[] = [];

  for (let keys = Object.keys(orderItems), i = 0, end = keys.length; i < end; i += 1) {
    const salesType = keys[i];
    let item: React.ReactNode = null;

    const checkouts = (orderItems as OrdersModel.OrderItems)[salesType];
    const hasNoSalesType = salesType === '' || salesType === 'No Sales Type';
    const salesTypeName = hasNoSalesType ? 'No Sales Type' : salesType;

    if (Object.keys(orderItems).length <= 1 && hasNoSalesType) {
      item = (
        <div key={i}>
          <ReceiptItemTable checkouts={checkouts} />
          {(hasDiscount || hasRewardRedemption) && (
            <>
              <hr />
              <div className="m-0 my-2 w-full rounded-lg bg-neutral-50 px-4 py-2 sm:ml-[50%] sm:w-[50%]">
                <ReceiptDiscountTable discounts={invoiceDetail.order_discounts} />
                {hasRewardRedemption && (
                  <RewardRedemptionInfo redeemReward={redeemReward} totalRedeemAmount={invoiceDetail.total_redeem_amount} />
                )}
              </div>
            </>
          )}
        </div>
      );
    } else if (i !== end - 1) {
      item = (
        <div key={i}>
          <Text weight="semibold" className="py-3 text-center" data-testid="sales-type">
            {salesTypeName}
          </Text>
          <hr />
          <ReceiptItemTable checkouts={checkouts} />
        </div>
      );
    } else {
      item = (
        <div key={i}>
          <hr />
          <Text weight="semibold" className="py-3 text-center" data-testid="sales-type">
            {salesTypeName}
          </Text>
          <hr />
          <ReceiptItemTable checkouts={checkouts} />

          {(hasDiscount || hasRewardRedemption) && (
            <>
              <hr />
              <div className="m-0 my-2 w-full rounded-lg bg-neutral-50 px-4 py-2 sm:ml-[50%] sm:w-[50%]">
                <ReceiptDiscountTable discounts={invoiceDetail.order_discounts} />
                {hasRewardRedemption && (
                  <RewardRedemptionInfo redeemReward={redeemReward} totalRedeemAmount={invoiceDetail.total_redeem_amount} />
                )}
              </div>
            </>
          )}
        </div>
      );
    }

    items.push(item);
  }

  return <div>{items}</div>;
}

export { ReceiptListItem };
